import { ApiEndpoints } from '@shared/api/api-endpoints';
import { mxApiClient } from '@shared/api/clients/apiClientFactory';
import {  MeterDeviceSearch, MxDashboardSummary } from './types';
import { transformJsonToObject } from '@shared/utils/jsonToObjectTransformer';
import { DeviceDetail } from '../types';

const getMeterSummaryDashboard = async (remoteUtilityId: string) :Promise<any> => {
  const url = ApiEndpoints.createUrlWithPathAndQueryVariables(
    'mx',
    'meter',
    ['summary', 'dashboard'],
    query => {
      query.push('remote_utility_id', remoteUtilityId);
    }
  );
  const response = await mxApiClient.get(url);
  return transformJsonToObject<any>(response.data.result);
};

const searchMeters = async ({
  searchField,
  searchData,
  remoteUtilityId,
}: {
  searchField: string;
  searchData: string;
  remoteUtilityId: string;
}) :Promise <MeterDeviceSearch[]> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    'mx',
    'search-meters',
    query => {
      query.push('search_field', searchField);
      query.push('search_data', searchData);
      query.push('remote_utility_id', remoteUtilityId);
    }
  );

  const response = await mxApiClient.get(url);
  return transformJsonToObject<MeterDeviceSearch[]>(response.data.result);
};

const getDeviceDetail = async ({
  meterId,
  remoteUtilityId,
}: {
  meterId: number;
  remoteUtilityId: string;
}): Promise<DeviceDetail> => {
  const url = ApiEndpoints.createUrlWithPathAndQueryVariables(
    'mx',
    `device-detail`,
    [meterId],
    query => {
      query.push('remote_utility_id', remoteUtilityId);
    }
  );

  const response = await mxApiClient.get(url);
  return transformJsonToObject<DeviceDetail>(response.data.result);
};

export const mxApi = {
  getMeterSummaryDashboard,
  searchMeters,
  getDeviceDetail,

 getValidationDashboard: async (params: { remote_utility_id: any }): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters('mx', 'validation-dashboard', (qs) => {
    qs.push('remote_utility_id', params.remote_utility_id);
  });
  const response = await mxApiClient.get(url);
  return response.data;
},

getRunWiseReadingValidationDashboard: async (params: { 
  remote_utility_id: string;
  meter_run_id: string;
}): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters('mx', 'run-wise-reading-validation-dashboard', (qs) => {
    qs.push('remote_utility_id', params.remote_utility_id);
    qs.push('meter_run_id', params.meter_run_id);
  });
  const response = await mxApiClient.get(url);
  return response.data;
},

getMeterConditionDashboard: async (params: { remote_utility_id: string }): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters('mx', 'meter-condition-dashboard', (qs) => {
    qs.push('remote_utility_id', params.remote_utility_id);
  });
  const response = await mxApiClient.get(url);
  return response.data;
},

getReadCycleValidationStats: async (params: { remote_utility_id: string }): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters('mx', 'read-cycle-validation-stats', (qs) => {
    qs.push('remote_utility_id', params.remote_utility_id);
  });
  const response = await mxApiClient.get(url);
  return response.data;
},

getValidationIssues: async (params: { remote_utility_id: string }): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters('mx', 'validation-issues', (qs) => {
    qs.push('remote_utility_id', params.remote_utility_id);
  });
  const response = await mxApiClient.get(url);
  return response.data;
},

getDailyValidationTrend: async (params: { remote_utility_id: string }): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters('mx', 'daily-validation-trend', (qs) => {
    qs.push('remote_utility_id', params.remote_utility_id);
  });
  const response = await mxApiClient.get(url);
  return response.data;
},

getValidationStats: async (params: { remote_utility_id: string }): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters('mx', 'validation-stats', (qs) => {
    qs.push('remote_utility_id', params.remote_utility_id);
  });
  const response = await mxApiClient.get(url);
  return response.data;
},

getMeterRunList: async (params: { 
  remote_utility_id: string;
  page?: number;
  exclude_run_status?: string;
  month_year?: string;
}): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters('mx', 'meter-run-list', (qs) => {
    qs.push('remote_utility_id', params.remote_utility_id);
    
    if (params.page) {
      qs.push('page', params.page);
    }
    if (params.exclude_run_status) {
      qs.push('exclude_run_status', params.exclude_run_status);
    }
    if (params.month_year) {
      qs.push('month_year', params.month_year);
    }
  });
  const response = await mxApiClient.get(url);
  return response.data;
},
};
